export default __webpack_public_path__ + "static/media/asoulforourfeast3.0578352e.png";